/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChromeFromJSONTyped, ChromeToJSON, } from './Chrome.js';
import { EdgeFromJSONTyped, EdgeToJSON, } from './Edge.js';
import { FirefoxFromJSONTyped, FirefoxToJSON, } from './Firefox.js';
import { InternetExplorerFromJSONTyped, InternetExplorerToJSON, } from './InternetExplorer.js';
import { OperaFromJSONTyped, OperaToJSON, } from './Opera.js';
import { OtherBrowserFromJSONTyped, OtherBrowserToJSON, } from './OtherBrowser.js';
import { SafariFromJSONTyped, SafariToJSON, } from './Safari.js';
export function BrowserFromJSON(json) {
    return BrowserFromJSONTyped(json, false);
}
export function BrowserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'chrome':
            return Object.assign(Object.assign({}, ChromeFromJSONTyped(json, true)), { type: 'chrome' });
        case 'edge':
            return Object.assign(Object.assign({}, EdgeFromJSONTyped(json, true)), { type: 'edge' });
        case 'firefox':
            return Object.assign(Object.assign({}, FirefoxFromJSONTyped(json, true)), { type: 'firefox' });
        case 'internet_explorer':
            return Object.assign(Object.assign({}, InternetExplorerFromJSONTyped(json, true)), { type: 'internet_explorer' });
        case 'opera':
            return Object.assign(Object.assign({}, OperaFromJSONTyped(json, true)), { type: 'opera' });
        case 'other_browser':
            return Object.assign(Object.assign({}, OtherBrowserFromJSONTyped(json, true)), { type: 'other_browser' });
        case 'safari':
            return Object.assign(Object.assign({}, SafariFromJSONTyped(json, true)), { type: 'safari' });
        default:
            throw new Error(`No variant of Browser exists with 'type=${json['type']}'`);
    }
}
export function BrowserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'chrome':
            return ChromeToJSON(value);
        case 'edge':
            return EdgeToJSON(value);
        case 'firefox':
            return FirefoxToJSON(value);
        case 'internet_explorer':
            return InternetExplorerToJSON(value);
        case 'opera':
            return OperaToJSON(value);
        case 'other_browser':
            return OtherBrowserToJSON(value);
        case 'safari':
            return SafariToJSON(value);
        default:
            throw new Error(`No variant of Browser exists with 'type=${value['type']}'`);
    }
}
